import FinancialAccountsTable from './FinancialAccountsTable'

type FinancialAccountsMembersViewProps = {
  memberId: string
}

const FinancialAccountsMembersView = ({
  memberId,
}: FinancialAccountsMembersViewProps) => {
  return (
    <div className='flex-col w-full h-full space-y-4 bg-white rounded-lg max-w-[2000px] mx-auto'>
      <div className='flex items-center justify-between w-full mb-4 gap-x-2'>
        <div className='heading-md'>VBAN Accounts</div>
      </div>
      <FinancialAccountsTable memberId={memberId} />
    </div>
  )
}

export default FinancialAccountsMembersView
